module.exports = "ngb-datepicker {\n  width: 235px !important; }\n\n.ngb-dp-month {\n  width: 100%; }\n\n.ngb-dp-weekdays,\n.ngb-dp-week {\n  -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-date/app-date.component.scss
// module id = ./src/app/components/app-date/app-date.component.scss
// module chunks = main